import Glide from '@glidejs/glide';

export default function (dom, opts) {
	let options = {
		type: 'carousel',
		perView: 1,
		gap: 0,
		keyboard: false,
		autoplay: false,
		breakpoints: {
			1279: {
				perView: 1,
			},
			767: {
				perView: 1,
				autoplay: 5000,
				hoverpause: true
			},
		},
		swipeThreshold: 80,
		dragThreshold: 120,
		perTouch: 0,
		touchRatio: 0.5,
		touchAngle: 45,
		rewind: true,
		...opts
	};


	const slideCount = [].slice.call(dom.querySelectorAll('.glide__slide'), 0).length;

	if (slideCount) {
		const glide = new Glide(dom.querySelector('.glide'), options).mount();

		let currentItem = dom.querySelector('.current-item');
		let maxItems = dom.querySelector('.max-items');

		if(currentItem) {
			currentItem.innerHTML = 1;

			glide.on("run.after", function () {
				currentItem.innerHTML = (glide.index + 1);
			});
		}

		if(maxItems) {
			maxItems.innerHTML = slideCount;
		}
	}
}
